/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderAlert,
    DigitizingserviceMelcoDigitizingModelsOrderAlertFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAlertFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderAlertToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert
 */
export interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsOrderAlert>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert
     */
    list: Array<DigitizingserviceMelcoDigitizingModelsOrderAlert>;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert
     */
    total: number;
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertFromJSON(json: any): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert {
    return DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAlertFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertToJSON(value?: DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAlertToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


